import { createContext, ReactNode, useContext, useMemo } from 'react';
import { DeployAsFlowOption } from '../../common/deploy-button/DeployButton';
import { AutomationDeployAs } from '../../../types/enums/AutomationDeployAs';
import { InvalidValidationReasons } from './deployToFlowHelper';
interface AutomationsFormValidationCtxType {
  _initialized: boolean;
  isDeployToSfValid: boolean;
  isDeployToFlowValid?: boolean;
  deployAsFlowOption?: DeployAsFlowOption;
  defaultDeployType: AutomationDeployAs;
  invalidValidationReasons?: InvalidValidationReasons[];
}

const AutomationsFormValidationCtx = createContext<AutomationsFormValidationCtxType>({
  _initialized: false,
  isDeployToSfValid: false,
  isDeployToFlowValid: false,
  invalidValidationReasons: [],
  defaultDeployType: AutomationDeployAs.AUTOMATION,
});

export const AutomationsFormValidationCtxProvider = ({
  children,
  defaultDeployType,
  isDeployToSfValid,
  deployAsFlowOption,
  isDeployToFlowValid,
  invalidValidationReasons,
}: {
  children: ReactNode;
} & Omit<AutomationsFormValidationCtxType, '_initialized'>) => {
  return (
    <AutomationsFormValidationCtx.Provider
      value={useMemo(
        () => ({
          _initialized: true,
          defaultDeployType,
          isDeployToSfValid,
          deployAsFlowOption,
          isDeployToFlowValid,
          invalidValidationReasons,
        }),
        [
          defaultDeployType,
          isDeployToSfValid,
          deployAsFlowOption,
          isDeployToFlowValid,
          invalidValidationReasons,
        ],
      )}
    >
      {children}
    </AutomationsFormValidationCtx.Provider>
  );
};

export const useAutomationsFormValidationCtx = () => {
  const ctx = useContext(AutomationsFormValidationCtx);
  if (!ctx._initialized) {
    throw new Error(
      'AutomationsFormValidationCtx must be used within AutomationsFormValidationCtxProvider',
    );
  }
  return ctx;
};
